var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.blocked)?_c('el-tooltip',{attrs:{"content":_vm.blockingReason}},[_c('el-tag',{attrs:{"type":"danger","size":"mini"}},[_vm._v(" "+_vm._s(_vm.labels.blocked)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }